import React, { useState } from 'react';
import { Upload, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { api } from 'react-structure-admin';

const Image = ({ uri }) => {
  return (
    <div>
      <img
        src={`${process.env.REACT_APP_API_URL}/${uri}`}
        alt="avatar"
        style={{ width: '100%' }}
      />
    </div>
  );
};

const UploadProfile = ({ value, onChange, resource }) => {
  const [loading, setLoading] = useState(false);

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

    if (!isJpgOrPng) {
      message.error('É permitido somente arquivos com a extensão JPG/PNG!');
    }

    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isLt2M) {
      message.error('O tamanho do arquivo não pode ser superior a 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };

  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }

    if (info.file.status === 'done' && onChange) {
      onChange(info.file.response.result);
    }
  };

  const uploadButton = (
    <div>
      {loading ? (
        <LoadingOutlined />
      ) : (
        <div className="gx-flex-row gx-align-items-center gx-text-grey">
          <FontAwesomeIcon className="icon gx-m-1" icon="download" size="2x" />
        </div>
      )}
    </div>
  );

  const handleCustomRequest = (options) => {
    const data = new FormData();

    data.append('profileImageFile', options.file);

    setLoading(true);

    api.post(resource, data).then((res) => {
      if (!(res && res.errors)) {
        options.onSuccess(res.data, options.file);
      } else {
        message.error('Ocorreu um erro inesperado.');
      }

      setLoading(false);
    });
  };

  return (
    <div>
      <Upload
        name="avatar"
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        customRequest={handleCustomRequest}
      >
        {value && !loading ? <Image uri={value?.uri} /> : uploadButton}
      </Upload>
    </div>
  );
};

export default UploadProfile;
